// In AuthContext.js
import { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from './firebase.js';
import { getUserProfile, setPatrolId } from './api.js';

const AuthContext = createContext();

const signOutUser = async () => {
    setPatrolId(null);
    await signOut(auth);
};

export const AuthProvider = ({ children }) => {
    const [ currentUser, setCurrentUser ] = useState(null);
    const [ token, setToken ] = useState(null);
    const [ patrolId, _setPatrolId ] = useState(null);
    const [ loading, setLoading ] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, user => {
            if (user) {
                user.getIdTokenResult().then(async (tokenResult) => {
                    setToken(tokenResult);

                    const profile = await getUserProfile(user.uid, tokenResult.token);
                    const pid = profile?.patrols?.[0] || null;
                    setPatrolId(pid);
                    _setPatrolId(pid);
                });
            } else {
                setToken(null);
                setPatrolId(null);
                _setPatrolId(null);
            }

            setCurrentUser(user);
            setLoading(false);
        });

        return unsubscribe;
    }, []);

    return (
        <AuthContext.Provider value={ { auth, currentUser, token: token?.token, claims: token?.claims, patrolId, signOutUser, loading } }>
            { children }
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
